import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import TooltipContainer from '../../forecast-app/shared/components/tooltips/tooltip_container';
import {isProjectDone, isProjectHalted, isProjectLocked, stageLabel} from '../../forecast-app/shared/util/projectStageUtil';
class ProjectStatusIndicator extends Component {
	render() {
		const {formatMessage} = this.props.intl;
		const project = {stage: this.props.stage};
		const label = isProjectLocked(project) ? stageLabel(this.props.stage, this.props.intl) : '';
		return (
			<TooltipContainer
				infoText={formatMessage({id: 'project_section.locked-info'}, {status: label.toLowerCase()})}
				width={188}
			>
				<div className={'project-status-indicator'}>
					{isProjectDone(project) ? (
						<div className={'done-indicator'}>
							<div className={'indicator-icon'} />
							<div className={'text'}>{label}</div>
						</div>
					) : isProjectHalted(project) ? (
						<div className={'halted-indicator'}>
							<div className={'indicator-icon'} />
							<div className={'text'}>{label}</div>
						</div>
					) : null}
				</div>
			</TooltipContainer>
		);
	}
}
ProjectStatusIndicator.propTypes = {
	stage: PropTypes.shape({
		id: PropTypes.string,
		name: PropTypes.string,
		profile: PropTypes.string,
	}),
};
export default injectIntl(ProjectStatusIndicator);
